module.exports = __webpack_public_path__ + "media/features/power-analysis-296bc55d.png";